/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { commonRoutes } from './route';
import Toast from '../component/Common/Toast';
import { useActions } from '../store/hooks/useActions';
import { getUserDataFromLocal } from '../shared/utility/helper';

// eslint-disable-next-line import/no-mutable-exports
const Home = () => {
  const { finalMenu } = useSelector((state) => state.home);
  const error = useSelector((state) => state.configData.error);
  const { setToastError, onLoginFail } = useActions();
  const clearError = () => {
    setToastError('');
  };

  const userData = getUserDataFromLocal();
  const authenticated = useSelector((state) => state.loginData.authenticated);

  if (authenticated && !userData?.token) {
    onLoginFail({ error: '' });
  }

  const homeMenu =
    finalMenu &&
    finalMenu.length > 0 &&
    [...finalMenu, ...commonRoutes].map((route, index) => {
      const { path, exact, name, Component, menuId } = route;
      const updatedHomePath = path.split('/home')[1];
      if (Component) {
        return (
          <Route
            key={index}
            path={updatedHomePath}
            exact={exact}
            name={name}
            element={<Component menuId={menuId} />}
          />
        );
      }

      return null;
    });

  return (
    <>
      <Routes>{homeMenu}</Routes>
      {error && (
        <Toast
          className='right'
          header='Error'
          message={error}
          fn={clearError}
        />
      )}
    </>
  );
};
export default Home;
